import React, { useEffect, useRef, useState, useContext } from 'react';
import { useRouter } from 'next/router';
import * as colors from 'Styles/colors';
import * as Shared from '../../ContentSystem.shared.styles';
import * as Styled from './TextSet.styled';
import TextToJSX from '../TextToJSX/TextToJSX';
import Eyebrow from '../Eyebrow/Eyebrow';
import Header from '../Header/Header';
import { handleNavigate } from '../../../../util/util';
import { getClosestLabel } from '../../utils/utils';
import { ContainerQueryContext } from '../../../../util/ContainerQuery.context';
export var CardTextSet = function (_a) {
    var _b, _c;
    var _d = _a.backgroundColor, backgroundColor = _d === void 0 ? 'white' : _d, cardType = _a.cardType, _e = _a.className, className = _e === void 0 ? undefined : _e, _f = _a.content, content = _f === void 0 ? {
        ctas: []
    } : _f, _g = _a.customBackgroundColor, customBackgroundColor = _g === void 0 ? undefined : _g, headerMaxLineLength = _a.headerMaxLineLength, _h = _a.responsiveSizes, responsiveSizes = _h === void 0 ? undefined : _h, textAlignment = _a.textAlignment, _j = _a.textColor, textColor = _j === void 0 ? 'AUTO' : _j;
    var router = useRouter();
    var ref = useRef(null);
    var _k = useState(null), dataLabel = _k[0], setDataLabel = _k[1];
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    useEffect(function () {
        var parentLabel = getClosestLabel(ref);
        setDataLabel(parentLabel);
    }, []);
    var autoColor = textColor === 'AUTO'
        ? Shared.getCompliantColorTheme({
            textColor: textColor,
            backgroundColor: customBackgroundColor || colors[backgroundColor]
        })
        : null;
    var lightHexCode = autoColor === 'LIGHT' || textColor === 'LIGHT' ? colors.white : undefined;
    var ButtonVariant = 'secondary';
    var ButtonColorMode = autoColor === 'LIGHT' || textColor === 'LIGHT' ? 'day' : 'night';
    var hasCTAs = !!((_b = content.ctas) === null || _b === void 0 ? void 0 : _b.some(function (_a) {
        var text = _a.text;
        return text;
    }));
    return (React.createElement(Styled.TextSet, { ref: ref, hasCTAs: hasCTAs, textAlignment: textAlignment, headerMaxLineLength: headerMaxLineLength, className: className, elementType: "card" },
        content.icon ? React.createElement(Shared.Icon, { src: content.icon.file.url }) : null,
        content.eyebrow && (React.createElement(Eyebrow, { lightHexCode: lightHexCode }, content.eyebrow)),
        content.header && (React.createElement(Header, { lightHexCode: lightHexCode }, content.header.toString())),
        (content === null || content === void 0 ? void 0 : content.body) && (React.createElement(TextToJSX, { text: content.body || '', lightHexCode: lightHexCode })),
        ((_c = content.ctas) === null || _c === void 0 ? void 0 : _c.filter(function (_a) {
            var text = _a.text;
            return text;
        }).length) ? (React.createElement(Shared.CTAGroup, { buttonOverflow: "WRAP", cardType: cardType }, content.ctas.map(function (_a, i) {
            var url = _a.url, text = _a.text, _b = _a.ctaStyle, ctaStyle = _b === void 0 ? 'LINK' : _b, as = _a.as;
            return (React.createElement(Shared.CTA, { as: as, href: url, onClick: function () { return url && handleNavigate(router, url); }, "data-label": "".concat(dataLabel, "_CTA").concat(i + 1), responsiveSizes: responsiveSizes, key: "".concat(url).concat(text).concat(i), lightHexCode: lightHexCode, variant: ButtonVariant, size: cardType === 'CONTENT_CARD_MEGA' ? 'medium' : 'small', ctaStyle: ctaStyle, colorMode: ButtonColorMode, "$styleQueryMode": styleQueryMode }, text));
        }))) : null));
};
export default {};
